import Box from '@mui/material/Box';

export const PageBreak = () => (
  <Box sx={{ pageBreakBefore: 'always', clear: 'both' }} />
);
